/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductChartMatchListQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetProductChartMatchListQuery = { __typename: 'Query', getProductChartMatchList: { __typename: 'ProductChartSimilarityResponse', total: number, items: Array<{ __typename: 'ProductChartSimilarity', artist_chart_name: string, artist_name: string, dv_entity_id: string, id: string, configuration: string, product_chart_name: string, product_id: number, product_name: string, score: number }> } };


export const GetProductChartMatchListDocument = gql`
    query getProductChartMatchList {
  getProductChartMatchList {
    items {
      artist_chart_name
      artist_name
      dv_entity_id
      id
      configuration
      product_chart_name
      product_id
      product_name
      configuration
      score
    }
    total
  }
}
    `;

/**
 * __useGetProductChartMatchListQuery__
 *
 * To run a query within a React component, call `useGetProductChartMatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductChartMatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductChartMatchListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductChartMatchListQuery(baseOptions?: Apollo.QueryHookOptions<GetProductChartMatchListQuery, GetProductChartMatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductChartMatchListQuery, GetProductChartMatchListQueryVariables>(GetProductChartMatchListDocument, options);
      }
export function useGetProductChartMatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductChartMatchListQuery, GetProductChartMatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductChartMatchListQuery, GetProductChartMatchListQueryVariables>(GetProductChartMatchListDocument, options);
        }
export type GetProductChartMatchListQueryHookResult = ReturnType<typeof useGetProductChartMatchListQuery>;
export type GetProductChartMatchListLazyQueryHookResult = ReturnType<typeof useGetProductChartMatchListLazyQuery>;